// Typelizer digest cb1a280acf1995ac11a8bae09a8c082f
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/questions/:question_id/messages */
  create: (
    params: { questionId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/questions/:question_id/messages', params, options),
    method: 'post',
  }),
}
